import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import { usePollSessionForFeedback } from '@/Pages/DatasetSessionCompare/utils/usePollSession';
import { usePlaygroundStore } from '@/Pages/Playground/PlaygroundHome/hooks/usePlaygroundStore';

export function useFeedbackColumnSorting({
  sessionId,
  evaluatorFeedbackKeys,
}: {
  sessionId?: string;
  evaluatorFeedbackKeys?: string[];
}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const sortBy = searchParams.get('sort_by');
  const sortOrder = searchParams.get('sort_order');

  const { session } = usePollSessionForFeedback(
    sessionId,
    evaluatorFeedbackKeys
  );
  const expectedNumberOfRuns = usePlaygroundStore(
    (state) => state.expectedNumberOfRuns
  );

  const setSortParams = useCallback(
    (feedbackKey: string) => {
      const newSearchParams = new URLSearchParams(searchParams);
      if (sortBy === feedbackKey) {
        if (sortOrder === 'ASC') {
          newSearchParams.set('sort_order', 'DESC');
        } else {
          newSearchParams.delete('sort_order');
          newSearchParams.delete('sort_by');
        }
      } else {
        newSearchParams.set('sort_by', feedbackKey);
        newSearchParams.set('sort_order', 'ASC');
      }
      setSearchParams(newSearchParams);
    },
    [searchParams, setSearchParams, sortBy, sortOrder]
  );

  return {
    sortBy,
    sortOrder,
    setSortParams,
    session,
    expectedNumberOfRuns,
  };
}
